import React from 'react';
import classNames from 'classnames';

import { ModalFooterProps } from '../types';
import styles from './index.module.scss';

const ModalFooter: React.FC<ModalFooterProps> = ({
    children,
    className,
    centered=false
}) => (
    <div className={
        classNames(
            'flex flex-items-center',
            {
                'flex-justify-center': centered,
                'flex-justify-end': !centered
            },
            styles.container,
            className
        )}>
        {children}
    </div>
);

ModalFooter.displayName = 'ModalFooter';

export default ModalFooter;
